import React from 'react';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import TitleXLText from 'shared/components/vxl/typography/primary/title/TitleXLText';

export interface TitleTextProps {
  titleText?: string;
  titleTextStyle?: 'large' | 'extra-large';
}

export function RenderText({ titleText, titleTextStyle }: TitleTextProps) {
  if (titleTextStyle === 'large') {
    return <TitleLgText numberOfLines={0}>{titleText}</TitleLgText>;
  } else if (titleTextStyle === 'extra-large') {
    return <TitleXLText numberOfLines={0}>{titleText}</TitleXLText>;
  }
}
